import type React from 'react';
import { useEffect } from 'react';

import { OnboardingProgressStep, useProgress } from '@/context/progress';
import BaseLayout from '@/layouts/base';

const PersonalInformationLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(OnboardingProgressStep.PERSONAL_INFORMATION);
  }, [setCurrentStep]);

  return <BaseLayout {...props} />;
};
PersonalInformationLayout.displayName = 'PersonalInformationLayout';

export default PersonalInformationLayout;
